import * as React from "react";

import "./type-xpresslinks.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";

import {InformationBadge} from "../../../../../common/design2/information-badge/information-badge";

export const TypeXpresslinks = ({itemId, next}) => cs(
    consumeContext("company"),
    consumeContext("systemConstants"),
    ["url", ({company, systemConstants}, next) => next(
        !itemId ? null : (
            systemConstants.value?.MN_XPRESSLINKS_URL +
            encodeURIComponent(btoa(JSON.stringify({
                idCompany: company.idCompany,
                idOrder: "" + itemId,
            })))
        )
    )],
    ({url}) => next({
        staticControl: true,
        activeUrl: url,
        renderControl: ({}) => cs(
            () => (
                <div className="type-xpresslinks-6hx">
                    <div {...{
                        className: "label",

                        "xd-qa-type": "label",
                        "xd-qa-name": "Redirect URL - Xpress Links",
                    }}>
                        Xpress Links
                    </div>

                    {InformationBadge({
                        getTooltip: () => "Sharable webpage with a contact form to capture leads. Turns print and direct mail campaigns into social media marketing.",
                        height: 14,
                        xdQaName: "Redirect URL - Xpress Links Information",
                    })}

                    {url && <a {...{
                        onClick: (e) => {
                            e.stopPropagation();
                            url && window.open(url);
                        },
                    }}>
                        Preview
                    </a>}
                </div>
            )
        ),
    }),
);

